import { __rest, __assign } from 'tslib';
import React from 'react';
import { Checkmark } from '../../checkmark-mobile/Component.js';
import { OptionBase } from '../Component.js';
import 'classnames';
import '@alfalab/icons-glyph/CheckmarkMIcon';
import '../../../consts.js';

var styles = {"option":"select__option_eepvo","disabled":"select__disabled_eepvo","size-48":"select__size-48_eepvo","size-56":"select__size-56_eepvo","size-64":"select__size-64_eepvo","size-72":"select__size-72_eepvo","selected":"select__selected_eepvo","highlighted":"select__highlighted_eepvo","content":"select__content_eepvo","textContent":"select__textContent_eepvo"};
require('./index.css');

var OptionMobile = function (_a) {
    var _b = _a.Checkmark, Checkmark$1 = _b === void 0 ? Checkmark : _b, props = __rest(_a, ["Checkmark"]);
    return (React.createElement(OptionBase, __assign({}, props, { mobile: true, Checkmark: Checkmark$1, styles: styles })));
};

export { OptionMobile };
